import React from 'react';

import Access from 'ui/Access';
import Users from './users/Users';
import Roles from './roles/Roles';
import Groups from './groups/Groups';

import PageTabs from 'ui/PageTabs';

import { withAppContext } from '../../AppContext';

const TAB_LIST = [
    {
        name: 'access',
        label: 'Portal Access',
        component: Users,
        access: Access.COMPANIES_PARTNER_USERS,
    },
    {
        name: 'roles',
        label: 'Roles',
        component: Roles,
        access: Access.COMPANIES_PARTNER_ROLES,
    },
    {
        name: 'company_groups',
        label: 'Company Groups',
        component: Groups,
        access: Access.COMPANIES_PARTNER_COMPANY_GROUPS,
    },
];

class PartnerPortal extends React.Component {
    state = {
        tabs: [],
        tab: -1,
    };

    componentDidMount() {
        const { organization } = this.props;
        this.updateTabs();
        this.props.updateBreadcrumbs([
            { name: 'Companies', path: '/companies' },
            organization.business_name,
        ]);
    }

    componentDidUpdate(oldProps) {
        const tabName = this.props.tab;
        const tab = this.findTabNumber(tabName);
        if (oldProps.tab !== tabName || tab !== this.state.tab) {
            this.setState({ tab });
        }
    }

    updateTabs() {
        const { app } = this.props;
        const accessFilter = tab => app.canView(tab.access);
        const tabs = TAB_LIST.filter(accessFilter);
        this.setState({ tabs });
    }

    findTab(num) {
        const { tabs } = this.state;
        return tabs[num] || tabs[0];
    }

    findTabNumber(tabName) {
        const { tabs } = this.state;
        for (let i = 0; i < tabs.length; i += 1) {
            if (tabs[i].name === tabName) {
                return i;
            }
        }
        return 0;
    }

    hasTab(num) {
        const { tabs } = this.state;
        return num < tabs.length;
    }

    findTabUrl(num) {
        const { id } = this.props;
        if (this.hasTab(num)) {
            return `/companies/${id}/partner/${this.findTab(num).name}`;
        }
        return '';
    }

    onTabChange = tab => {
        const { organization } = this.props;
        if (tab !== this.state.tab) {
            this.setState({ tab });
            if (this.hasTab(tab)) {
                this.props.history.push(this.findTabUrl(tab), { organization });
            }
        }
    };

    render() {
        const { tabs, tab } = this.state;
        const { id } = this.props;
        if (tab === -1) {
            return null;
        }
        return (
            <PageTabs
                tabs={tabs.map(tab => tab.label)}
                current={tab}
                onChange={this.onTabChange}
                secondary
            >
                {() => {
                    const currentTab = this.findTab(tab);
                    const ComponentTab = currentTab.component;
                    return <ComponentTab companyId={id} />;
                }}
            </PageTabs>
        );
    }
}

export default withAppContext(PartnerPortal);
